export default __webpack_public_path__ + "static/media/notifications.bfe23320.svg";